import React from 'react';
import { useTranslation } from 'react-i18next';
import LAdmin from '../layouts/LAdmin';
import { Helmet } from 'react-helmet';
import CAppTitle from '../../../app/components/CAppTitle';
import FAdminEmailNotifications from '../features/email-notifications/FAdminEmailNotifications';
import langAdminEmailNotifications from '../langs/langAdminEmailNotifications';

const PAdminEmailNotifications = () => {
	const { t } = useTranslation();
	return (
		<LAdmin>
			<Helmet>
				<title>IRP Admin tools - {t(langAdminEmailNotifications.title.tag)}</title>
			</Helmet>
			<CAppTitle title={t(langAdminEmailNotifications.title.tag)} id="title-admin-emails-notifications" />
			<FAdminEmailNotifications />
		</LAdmin>
	);
};

export default PAdminEmailNotifications;
